import { render, staticRenderFns } from "./theX-video.vue?vue&type=template&id=fd6e4cc2&scoped=true&"
import script from "./theX-video.vue?vue&type=script&lang=js&"
export * from "./theX-video.vue?vue&type=script&lang=js&"
import style0 from "./theX-video.vue?vue&type=style&index=0&id=fd6e4cc2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6e4cc2",
  null
  
)

export default component.exports